import { Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import { Budget } from 'typings'
import { useFormStateContext } from 'ui'
import { FormAliasKeys, useFormAlias } from 'ui/providers/useFormAlias.constate'
import { messages } from './messages'
import { styles } from './styles'

export function BudgetWarning() {
  const { form } = useFormStateContext()

  const { getAlias } = useFormAlias()

  const budget: Budget | undefined = useWatch({
    form,
    name: getAlias(FormAliasKeys.budgetRestrictions) ?? '',
  })

  if (!budget) return null

  return (
    <div className={styles.budgetWarninig}>
      <Text variant="body" tone="secondary">
        <FormattedMessage {...messages.budgetWarning} />
      </Text>
    </div>
  )
}
